export default __webpack_public_path__ + "files/7ce32e5ddf4ceb0c38f65a3f75e64001.mp3";